import config from 'config';

const {
  constants: {
    API: { PRICING_UPDATE_URL },
  },
} = config;

const API_BASE_URL = PRICING_UPDATE_URL;


const defaultHeaders = {
  'Content-Type': 'application/json',
};



const apiService = {
  get: async (endpoint, params = {}, format = 'json') => {
    const headers = {
      'Content-Type': 'application/json',
      'x-auth-token': window.appAuthToken, // Always fetch latest token
    };
    try {
      const url = new URL(`${API_BASE_URL}${endpoint}`);

      // Append query parameters (if any)
      Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));

      const response = await fetch(url, {
        method: 'GET',
        headers,
      });
      return handleResponse(response, format);
    } catch (error) {
      console.error('API GET Error:', error);
      throw error;
    }
  },

  post: async (endpoint, body) => {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {...defaultHeaders, 'x-auth-token': window.appAuthToken},
        body: JSON.stringify(body),
      });

      return handleResponse(response);
    } catch (error) {
      console.error('API POST Error:', error);
      throw error;
    }
  },

  put: async (endpoint, body) => {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'PUT',
        headers: {...defaultHeaders, 'x-auth-token': window.appAuthToken},
        body: JSON.stringify(body),
      });

      return handleResponse(response);
    } catch (error) {
      console.error('API PUT Error:', error);
      throw error;
    }
  },

  patch: async (endpoint, body) => {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'PATCH',
        headers: {...defaultHeaders, 'x-auth-token': window.appAuthToken},
        body: JSON.stringify(body),
      });

      return handleResponse(response);
    } catch (error) {
      console.error('API PATCH Error:', error);
      throw error;
    }
  },

  delete: async (endpoint,body = null) => {
    const headers = {
      'Content-Type': 'application/json',
      'x-auth-token': window.appAuthToken, // Always fetch latest token
    };
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'DELETE',
        headers,
        ...(body ? { body: JSON.stringify(body) } : {})
      });

      return handleResponse(response);
    } catch (error) {
      console.error('API DELETE Error:', error);
      throw error;
    }
  },
};

// Common response handler
const handleResponse = async (response, format = 'json') => {
  const status = response.status;

  let responseData;
  if (format === 'json') {
    responseData = await response.json();
  } else if (format === 'text') {
    responseData = await response.text();
  } else if (format === 'blob') {
    responseData = await response.blob();
  }

  if (!response.ok) {
    const errorMsg = typeof responseData === 'object'
      ? responseData.message || responseData?.errorMessage || 'Unknown error'
      : responseData;

    throw new Error(errorMsg);
  }
  return { status, data: responseData };
};

export default apiService;
